import { render, staticRenderFns } from "./TenantPolicyList.vue?vue&type=template&id=364b4fbc&"
import script from "./TenantPolicyList.vue?vue&type=script&lang=ts&"
export * from "./TenantPolicyList.vue?vue&type=script&lang=ts&"
import style0 from "./TenantPolicyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports